import React from 'react';
import { PsPage } from '../../../shared/components/ps-page/PsPage';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import WorkListCard from '../../../shared/work/list/WorkListCard';
import { PsCompanyManagement } from '../../../shared/model/PsCompanyManagement';
import { BreadcrumbsManagerInstance } from '../../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../../shared/breadcrumbs/Breadcrumbs';
import { CardStorageManager } from '../../../shared/utils/CardStorageManager';

export class WorkListScreen extends React.Component {

    cardStorageManager = new CardStorageManager(this.props.location.pathname);

    constructor(props) {
        super(props);

        this.cardStorageManager.init();

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.MY_CONTRACTORS,
            Breadcrumbs.MY_CONTRACTORS_WORKS,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    render() {
        const { breadcrumbs } = this.state;

        return (
            <PsPage title={I18nUtils.tr('TR_OBRAS_DE_MIS_CONTRATISTAS')} breadcrumbs={breadcrumbs}>
                <WorkListCard
                    companyManagement={PsCompanyManagement.MY_CONTRACTORS}
                    saveCardState={this.saveCardState}
                    initialCardState={this.readCardState()}
                />
            </PsPage>
        );
    }

    saveCardState = (state) => {
        this.cardStorageManager.saveCard('contractorWorks', state);
    };

    readCardState = () => {
        return this.cardStorageManager.readCard('contractorWorks');
    };
}



// WEBPACK FOOTER //
// ./src/app/my-contractors/work/list/WorkListScreen.jsx